import { render, staticRenderFns } from "./ModalInputText.vue?vue&type=template&id=3b12da78&scoped=true&lang=pug&"
import script from "./ModalInputText.vue?vue&type=script&lang=ts&"
export * from "./ModalInputText.vue?vue&type=script&lang=ts&"
import style0 from "./ModalInputText.vue?vue&type=style&index=0&id=3b12da78&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b12da78",
  null
  
)

export default component.exports